import React from 'react'
import { Menu } from 'antd'

const MenuItem = Menu.Item

export const dropDownList = [
    "operation",
    "summary",
    "id",
    "actor_id",
    "resource_id",
    "actor_name",
    "resource_name",
    "actorEmail",
    "configId",
    "configName",
    "configValue",
    "appType",
    "oldRecord",
    "newRecord",
    "collId",
    "collName",
    "versionId",
    "versionCode",
    "journeyId",
    "journeyName",
    "branchId",
    "branchName",
    "branchedFrom",
    "deployId",
    "deployName",
    "envId",
    "envName",
    "envType",
    "envUrl",
    "formId",
    "formName",
    "funcId",
    "funcName",
    "policyDescription",
    "permissionIds",
    "teamId",
    "policyId",
    "serviceId",
    "serviceName",
    "userId",
    "userIds",
    "teamDescription"
]

interface Props {
    setQueryProp: React.Dispatch<React.SetStateAction<string>>,
    queryProp: string
}

export const AuditPropsDropDown = (props: Props) => {

    return (
        <div data-test-id="audit-dropdown-menu-div">
            <Menu
                data-test-id="audit-dropdown-menu-container"
                onClick={(e) => {
                    props.setQueryProp(`${e.key} : `)
                }}
                selectedKeys={[]}
            >
                {
                    dropDownList.filter((item: string) => item.includes(props.queryProp))
                        .map((item: string) => {
                            return (
                                <MenuItem data-test-id={`audit-dropdown-menu-item-${item}`} key={item}>{`${item.slice(0, 1).toUpperCase()}${item.slice(1)}`}</MenuItem>
                            )
                        })
                }
            </Menu>
        </div>
    )

}